// extracted by mini-css-extract-plugin
module.exports = {"main":"market_main__22Ukf","search":"market_search__b0oMw","topSearch":"market_topSearch__j1L5B","content":"market_content__mU89E"};